module.exports = __webpack_public_path__ + "static/img/prev.6761dc6e.svg";